export enum EmailPriority {
    Low = "Low",
    Normal = "Normal",
    High = "High",
}

export default EmailPriority;
